import React from 'react';
import {ConnectedRouter as Router} from 'connected-react-router';
import {
  Switch,
  Route,
} from 'react-router-dom';
import {history} from '../store/configureStore';
import Registration from '../pages/Registration';
import Step from './Step';
import RedirectToClient from '../pages/RedirectToClient';
import {pathnames as P} from '../constants/pathnames';
import {usePageViews} from '../utils/usePageViews';

const PageViews = () => {
  usePageViews();

  return null;
};

const Root = () => (
  <Router history={history}>
    <PageViews />
    <Switch>
      <Route path={P.REGISTRATION} render={Registration}/>
      <Route path={P.STEP} render={Step}/>
      <Route path={P.HOME} exact render={RedirectToClient}/>
    </Switch>
  </Router>
);

export default Root;
